import React from 'react'
import CardPrivilegeSelectItem from './CardPrivilegeSelectItem'
import { isEmpty } from 'lodash'

export default ({
  isShow,
  onHide,
  card,
  classToServiceMapping,
  onCardPrivilegeSelect,
}) => {
  if (!isShow) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black bg-opacity-50" onClick={onHide} />
      <div className="relative bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h1 className="text-2xl font-bold text-gray-900">
            CHOOSE CARD PRIVILEGE
          </h1>
          <button
            onClick={onHide}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Close"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className="p-6 overflow-y-auto">
          {renderPrivilegeMenu(
            card,
            classToServiceMapping,
            onCardPrivilegeSelect,
          )}
        </div>
      </div>
    </div>
  )
}

const renderPrivilegeMenu = (
  card,
  classToServiceMapping,
  onCardPrivilegeSelect,
) => {
  if (!card || !classToServiceMapping)
    return <div className="text-gray-600">No Privileges for this card</div>

  return (
    <div>
      {renderEmptyStateIfNeeded(classToServiceMapping)}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {classToServiceMapping.map((classToServiceMapping) => (
          <div key={classToServiceMapping._id}>
            <CardPrivilegeSelectItem
              classToServiceMapping={classToServiceMapping}
              onClick={() => onCardPrivilegeSelect(card, classToServiceMapping)}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

const renderEmptyStateIfNeeded = (classToServiceMapping) => {
  if (isEmpty(classToServiceMapping)) {
    return (
      <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 mb-4">
        <h3 className="text-lg font-semibold text-gray-700">
          No privileges for this type of card and service
        </h3>
      </div>
    )
  }

  return null
}
